import type {Action} from '@yandex-delivery/types/schemas/services/cargo-c2c/definitions/delivery-state-actions'

import type {ActionOpenChat, ContentBarcodeItem} from '../types'
import type {WebTrackingResponse} from '../types/webState'

// Реальный ответ /4.0/cargo-c2c/v1/web/state для НДД, см. CARGODEV-78347.
// Каст через unknown: в @yandex-delivery/types ещё нет chat_with_bot/chat_meta/chat_icon,
// см. TODO в src/api/types.ts
const openChatAction: ActionOpenChat = {
  type: 'open_chat',
  title: 'Помощь',
  messenger_params: {
    messenger_header: {
      title: 'Доставка',
      subtitle: 'Задайте вопрос',
      chat_icon: 'delivery_messenger_chat_icon',
    },
    chat_request: {
      type: 'chat_with_bot',
      bot_id: '9f720c06-dd11-91de-53d8-9b71c58e626e',
    },
    chat_meta: {
      locale: 'ru',
      order_id: 'mock-lp-order-id-udp',
    },
  },
  image_tag: 'delivery_chat_bot_action_icon',
  metrica_label: 'Delivery.Tracking.Action.OpenChat',
}

const webStateAuthMock: WebTrackingResponse = {
  state: {
    context: {
      display_targets: ['multiorder'],
      is_performer_position_available: true,
      performer_search: {
        is_in_progress: false,
      },
      provider_status: 'delivering',
      provider_tariff_class: 'express',
      role: 'initiator',
    },
    summary: 'Курьер везёт посылку',
    description: 'Силантий едет к вам',
    icon_strategy: {
      image_tag: 'delivery_icon_smile_box_tracking',
      type: 'remote_image',
    },
    sorted_route_points: [
      {
        visit_status: 'visited',
        type: 'source',
        uri: 'ytpp://Москва ТЦ Lotte Plaza/Новый Арбат',
        coordinates: [37.58361702264886, 55.75212967591372],
        full_text: 'Россия, Москва, ТЦ Lotte Plaza, улица Новый Арбат',
        short_text: 'ТЦ Lotte Plaza, улица Новый Арбат',
        area_description: 'Москва, Россия',
        contact: {
          phone: '+79645256760',
        },
      },
      {
        visit_status: 'pending',
        type: 'destination',
        uri: 'ymapsbm1://geo?ll=37.633%2C55.753',
        coordinates: [37.63146303208137, 55.752516239669774],
        full_text: 'Россия, Москва, улица Варварка, 14с1',
        short_text: 'улица Варварка, 14с1',
        area_description: 'Москва, Россия',
        entrance: '5',
        floor: '5',
        room: '2',
        code: '9',
        contact: {
          phone: '+79645256760',
        },
      },
    ],
    active_route_points: [1],
    performer: {
      name: 'Ершов Силантий Фомич',
      short_name: 'Силантий',
      vehicle_model: 'Lexus LS',
      vehicle_number: 'Х265УР777',
      rating: '5.0',
      phone: '+79099999999',
      image_tag_default: 'performer_default',
    },
    performer_route: {
      sorted_route_points: [
        {
          coordinates: [37.6, 55.75],
        },
        {
          coordinates: [37.63146303208137, 55.752516239669774],
        },
      ],
    },
    content_sections: [
      {
        id: 'pickup_code_section',
        items: [
          {
            type: 'text_widget',
            id: 'pickup_code_widget',
            title: {
              text: '98576',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            subtitle: {
              text: 'Код выдачи',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            title_alignment: 'center',
            subtitle_alignment: 'center',
          },
          {
            type: 'separator',
            id: 'under_pickup_code',
          },
          {
            type: 'barcode',
            id: 'pickup_barcode',
            barcode: {
              barcode: 'LO-1691687-98576',
              type: 'barcode_string',
            },
            orientation: 'horizontal',
            subtitle: 'Штрихкод для выдачи',
            trail_image_tag: 'delivery_barcode_open',
            action: {
              type: 'action-payload',
              action: {
                type: 'show_content_sections',
                content_sections: [
                  {
                    id: 'barcode_modal_section',
                    items: [
                      {
                        id: 'barcode_modal_title',
                        title: {
                          color: 'TextMain',
                          max_lines: 2,
                          text: 'Покажите этот штрихкод\nв пункте выдачи',
                          typography: 'body2',
                        },
                        type: 'list_item',
                      },
                      {
                        id: 'barcode_modal_code',
                        barcode: {
                          barcode: 'LO-1691687-98576',
                          type: 'barcode_string',
                        },
                        orientation: 'vertical',
                        type: 'barcode',
                      },
                      {
                        id: 'barcode_modal_details',
                        subtitle: {
                          color: 'TextMinor',
                          max_lines: 10,
                          text: 'Номер заказа',
                          typography: 'caption1',
                        },
                        title: {
                          color: 'TextMain',
                          max_lines: 2,
                          text: 'LO-1691687',
                          typography: 'body2',
                        },
                        trail_subtitle: {
                          color: 'TextMinor',
                          max_lines: 10,
                          text: 'Код выдачи',
                          typography: 'caption1',
                        },
                        trail_text: {
                          color: 'TextMain',
                          max_lines: 10,
                          text: '98576',
                          typography: 'body2',
                        },
                        type: 'list_item',
                      },
                    ],
                  },
                ],
                maximize_screen_brightness: true,
              },
            },
          } as unknown as ContentBarcodeItem,
          {
            type: 'separator',
            id: 'under_barcode',
          },
        ],
      },
      {
        id: 'requirements',
        items: [
          {
            id: 'door_to_door',
            title: {
              text: 'От двери до двери',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            trail_text: {
              text: 'Включено',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            lead_icon: {
              image_tag: 'delivery_door_to_door',
            },
            type: 'list_item',
          },
        ],
      },
      {
        id: 'main_section',
        items: [
          {
            id: 'payment',
            title: {
              text: 'Доставка',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            trail_text: {
              text: 'Оплачено',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            lead_icon: {
              image_tag: 'delivery_payment_default',
            },
            type: 'list_item',
          },
          {
            id: 'under_payment',
            type: 'separator',
          },
          {
            id: 'details',
            title: {
              text: 'Детали заказа',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            subtitle: {
              text: 'Экспресс · 386 ₽',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            lead_icon: {
              image_tag: 'delivery_info',
            },
            sections: [
              {
                items: [
                  {
                    title: 'Тариф Экспресс',
                    subtitle: '25 июня 9:17',
                    type: 'subtitle',
                  },
                  {
                    title: 'От двери до двери',
                    subtitle: 'Включено',
                    type: 'subtitle',
                  },
                  {
                    title: '386 ₽',
                    subtitle: 'Стоимость',
                    type: 'subtitle',
                  },
                  {
                    title: 'Способ оплаты',
                    subtitle: 'Оплачено',
                    type: 'subtitle',
                  },
                ],
              },
              {
                title: 'Поставщик услуги доставки',
                items: [
                  {
                    title: 'Ершов Силантий Фомич',
                    subtitle: 'оранжевый Lexus LS, номер Х265УР777',
                    trail_payload: {
                      buffer: 'Ершов Силантий Фомич, оранжевый Lexus LS, номер Х265УР777',
                      in_app_notification_text: 'Информация о курьере скопирована',
                      type: 'copy-payload',
                    },
                    type: 'subtitle',
                  },
                  {
                    title: 'Вадим Данилов Cargocheck',
                    type: 'subtitle',
                  },
                  {
                    title: 'Дополнительно о партнёре',
                    items: [
                      {
                        title: 'Льва Толстого 16',
                        type: 'subtitle',
                      },
                      {
                        title: 'Часы работы: 9:00-18:00',
                        type: 'subtitle',
                      },
                    ],
                    type: 'accordion',
                  },
                ],
              },
            ],
            metrica_label: 'Delivery.Tracking.Item.Details',
            type: 'details',
          },
          {
            id: 'performer_header',
            title: {
              text: 'Исполнитель',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            type: 'header',
          },
          {
            id: 'performer_name',
            title: {
              text: 'Ершов Силантий Фомич',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            type: 'list_item',
          },
          {
            id: 'under_performer_name',
            type: 'separator',
          },
          {
            id: 'performer_vehicle',
            title: {
              text: 'Авто',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            subtitle: {
              text: 'оранжевый Lexus LS, Х265УР777',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            type: 'list_item',
          },
          {
            id: 'recipient_header',
            title: {
              text: 'Получатель',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            type: 'header',
          },
          {
            id: 'recipient_phone',
            title: {
              text: 'Телефон для связи',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            subtitle: {
              text: '+79645256760',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
              ignore_rtl: true,
            },
            lead_icon: {
              image_tag: 'delivery_phone',
            },
            type: 'list_item',
          },
          {
            id: 'under_recipient_phone',
            type: 'separator',
          },
          {
            id: 'recipient_address',
            title: {
              text: 'улица Варварка, 14с1',
              typography: 'body2',
              color: 'TextMain',
              max_lines: 1,
            },
            subtitle: {
              text: 'кв. 2, под. 5, этаж 5, домофон 9',
              typography: 'caption1',
              color: 'TextMinor',
              max_lines: 1,
            },
            lead_icon: {
              image_tag: 'delivery_point',
            },
            type: 'list_item',
          },
        ],
      },
    ],
    primary_actions: [
      {
        type: 'order_more',
        title: 'Оформить ещё один',
        vertical: 'express',
        vertical_trap: false,
        sheet_expansion: 'collapsed',
      },
      {
        type: 'open_universal_link',
        title: 'Как добраться',
        url: 'https://yandex.ru/maps/?whatshere[point]=37.631%2C55.752&whatshere[zoom]=17',
        image_tag: 'delivery_route_construction',
        dialog: {
          title: 'Показать на Яндекс Картах?',
          body: 'Вы сможете посмотреть, как добраться до получателя',
          close_button: {title: 'Нет, спасибо'},
          confirm_button: {title: 'Да, конечно'},
        },
      },
    ],
    secondary_actions: [
      {
        type: 'cancel_v2',
        title: 'Отменить доставку',
        message: {
          title: 'Хотите отменить заказ?',
          body: 'Если отменить его и создать новый, это не будет быстрее — поиск начнётся с нуля',
          buttons: [
            {
              title: 'Отменить заказ',
              highlighted: false,
              action: {type: 'continue_order_cancellation'},
            },
            {
              title: 'Подождать ещё',
              highlighted: true,
              action: {type: 'dismiss_cancel_message'},
            },
          ],
        },
        cancel_type: 'free',
      },
      openChatAction as unknown as Action,
      {
        type: 'extend_delivery_expiration_date',
        title: 'Продлить',
        badge_text: 'Хранится до 25 апреля включительно',
      },
    ],
    timeline: {
      bubble: {
        background: {
          alpha_day: 1,
          alpha_night: 1,
          color_day: 'f5f4f2',
          color_night: '302f2d',
        },
        button: {
          title: 'Узнать',
          action: {
            type: 'detail_timeline',
            title: 'Детали доставки',
            done_button: {
              text: 'Закрыть',
            },
            vertical: [
              {
                lead_title: '17 июня',
                lead_subtitle: '13:40',
                status: 'passed',
                title: 'Создан',
                title_color: {
                  alpha_day: 1,
                  alpha_night: 1,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
                subtitle_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
              },
              {
                lead_title: '17 июня',
                lead_subtitle: '13:44',
                status: 'passed',
                title: 'Принят пунктом приёма',
                subtitle: 'Ленинградский проспект 27, Москва',
                title_color: {
                  alpha_day: 1,
                  alpha_night: 1,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
                subtitle_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
              },
              {
                lead_title: '17 июня',
                lead_subtitle: '13:47',
                status: 'passed',
                title: 'Приехал в сортировочный центр',
                subtitle: 'Москва',
                title_color: {
                  alpha_day: 1,
                  alpha_night: 1,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
                subtitle_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
              },
              {
                lead_title: '17 июня',
                lead_subtitle: '13:47',
                status: 'passed',
                title: 'Едет в сортировочный центр',
                subtitle: 'Ленинградский проспект 27, Москва',
                title_color: {
                  alpha_day: 1,
                  alpha_night: 1,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
                subtitle_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
              },
              {
                lead_title: '17 июня',
                lead_subtitle: '13:47',
                status: 'passed',
                title: 'Отгружен из сортировочного центра',
                subtitle: 'Москва',
                title_color: {
                  alpha_day: 1,
                  alpha_night: 1,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
                subtitle_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
              },
              {
                lead_title: '17 июня',
                lead_subtitle: '13:48',
                status: 'passed',
                title: 'Принят пунктом выдачи',
                subtitle: 'улица Малая Ордынка 5/6 стр2-3, Москва',
                title_color: {
                  alpha_day: 1,
                  alpha_night: 1,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
                subtitle_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
              },
              {
                lead_title: '17 июня',
                lead_subtitle: '13:49',
                status: 'passed',
                title: 'Ждёт вручения в пункте выдачи',
                subtitle: 'Срок хранения до 6 июля',
                title_color: {
                  alpha_day: 1,
                  alpha_night: 1,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
                subtitle_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
              },
              {
                lead_title: '17 июня',
                lead_subtitle: '13:51',
                status: 'passed',
                title: 'Изменён срок хранения в пункте выдачи',
                subtitle: 'До 13 июля',
                title_color: {
                  alpha_day: 1,
                  alpha_night: 1,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
                subtitle_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
              },
              {
                status: 'pending',
                title: 'Доставлен',
                title_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
                subtitle_color: {
                  alpha_day: 0.5,
                  alpha_night: 0.5,
                  color_day: '21201f',
                  color_night: 'e0deda',
                },
              },
            ],
          },
        },
        lead_icon_tag: 'delivery_timeline_status_thumbs_up_green',
        title: 'Курьер везёт посылку — всё идёт по плану',
      },
      horizontal: [
        {
          id: 'accepted',
          status: 'passed',
          image_tag: 'delivery_timeline_hourglass',
          image_tag_dark: 'delivery_timeline_hourglass',
        },
        {
          id: 'transporting',
          status: 'passed',
          image_tag: 'delivery_timeline_delivery_delivering',
          image_tag_dark: 'delivery_timeline_delivery_delivering',
        },
        {
          id: 'delivering',
          status: 'passed',
          image_tag: 'delivery_timeline_delivery_delivering',
          image_tag_dark: 'delivery_timeline_delivery_delivering',
        },
        {
          id: 'delivered',
          status: 'pending',
          image_tag: 'delivery_timeline_check',
          image_tag_dark: 'delivery_timeline_check',
        },
      ],
      current_item_id: 'delivering',
    },
    meta: {},
  },
}

export default webStateAuthMock
